// Fond de modale partagé : clic hors du panneau ou Esc ferme. Le handler Esc
// lit la dernière valeur de onClose sans se réabonner à chaque rendu.

import { useEffect, useRef } from "react";

export function Overlay({
  children,
  onClose,
  maxWidth = "max-w-md",
  paddingTop = "pt-32",
}: {
  children: React.ReactNode;
  onClose: () => void;
  maxWidth?: string;
  paddingTop?: string;
}) {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === "Escape") onCloseRef.current();
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, []);
  return (
    <div className={`fixed inset-0 z-50 flex items-start justify-center ${paddingTop} bg-black/30`} onClick={onClose}>
      <div className={`bg-white rounded-lg shadow-xl w-full ${maxWidth} mx-4`} onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>
  );
}
